<template>
  <WidgetTestContainer>
    <script type="text/x-epodroznik-module"
            data-module-name="ConnectionsSearcher"
            id="ConnectionsSearcher"></script>
    <script type="text/x-epodroznik-module" data-module-name="UserMenu"
            id="UserMenu"></script>
    <div ref="content"></div>
  </WidgetTestContainer>
</template>

<script>
  import '../assets/less/style-account.less'
  import WidgetTestContainer from '../components/WidgetTestContainer'

  export default {
    components: {
      WidgetTestContainer
    },
    data() {
      return {}
    },
    computed: {
      // link() {
      //   const locale = this.$store.state.locales[this.$store.state.currentLocale]
      //   const lang = locale.regional.slice(0, 2)
      //   return `https://b2c.amadeusinsurance.com/bucket/7e1c83f94c8c2cf926cfcd187a1a3ac4?lang=${lang}`
      // }
    },
    mounted() {
      const scriptMain = document.createElement('script')
      scriptMain.setAttribute('type', 'text/javascript')
      scriptMain.setAttribute('src', 'https://www.e-podroznik.pl/public/jslib.do')

      this.$refs['content'].appendChild(scriptMain)

    }
  }
</script>

<style lang="less">

</style>
